import React, { FunctionComponent } from 'react'
import Image from 'next/image'
import { Text } from '@afterpaytouch/core'
import styles from './styles.module.css'

interface TileProps {
  image: string
  imageAlt: string
  title: string
  description: string
}

export const Tile: FunctionComponent<TileProps> = ({ image, imageAlt, title, description }: TileProps) => {
  return (
    <div className={styles.tileContainer}>
      <Image src={image} alt={imageAlt} width={327} height={160} />

      <div className={styles.tileContent}>
        <Text bold size='XL'>
          {title}
        </Text>
        <Text size='S'>{description}</Text>
      </div>
    </div>
  )
}
